import { PolicyResource } from "@vmosolutions/oc-interfaces";
import { ITableColumn } from "src/components/FilterSearchTable/TableComponents/TableHeader";

// BID PAIRINGS
export const bidPairingsTableDesc = {
  tableTitle: "",
  tableDescription: "",
  noMessage: "No bid pairings to display. Load using button above if already added to package.",
};
export const bidPairingsTableInfo: ITableColumn[] = [
  {
    id: "_id",
    value: "_id",
    index: 0,
    numeric: true,
    label: "Bid Pairing Id",
    type: "string",
    width: 10,
    visible: false,
    filter: false,
    sort: false,
  },
  {
    id: "state",
    value: "state",
    index: 1,
    numeric: false,
    label: "Package Status",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: false,
  },
  {
    id: "pairingShortCode",
    value: "pairingShortCode",
    index: 2,
    numeric: true,
    label: "Short Code",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: false,
  },
  {
    id: "positions",
    value: "positions",
    index: 3,
    numeric: true,
    label: "Positions",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "eventGroups",
    value: "eventGroups",
    index: 4,
    numeric: true,
    label: "Pairing Events",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "logicModifiers",
    value: "logicModifiers",
    index: 5,
    numeric: true,
    label: "LMs",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "pairing[displayPairing][start]",
    value: "pairing[displayPairing][start]",
    index: 6,
    numeric: true,
    label: "Check-In",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "pairing[displayPairing][end]",
    value: "pairing[displayPairing][end]",
    index: 7,
    numeric: true,
    label: "Check-Out",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "pairing[pairingSummary]",
    value: "pairing[pairingSummary]",
    index: 8,
    numeric: false,
    label: "Bid Pairing Summary",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "shortDescription",
    value: "shortDescription",
    index: 9,
    numeric: true,
    label: "Short Description",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: false,
  },
  // {
  //   id: "baseICAO",
  //   value: "baseICAO",
  //   index: 6,
  //   numeric: true,
  //   label: "Base",
  //   type: "string",
  //   width: 10,
  //   visible: true,
  //   filter: true,
  // },
  // {
  //   id: "foreignRef",
  //   value: "foreignRef",
  //   index: 7,
  //   numeric: true,
  //   label: "Foreign Id",
  //   type: "array",
  //   width: 10,
  //   visible: true,
  //   filter: true,
  // },
  // {
  //   id: "batchId",
  //   value: "batchId",
  //   index: 8,
  //   numeric: true,
  //   label: "Batch Id",
  //   type: "array",
  //   width: 10,
  //   visible: true,
  //   filter: true,
  // },
  // {
  //   id: "createdBy",
  //   value: "createdBy",
  //   index: 9,
  //   numeric: true,
  //   label: "Created By",
  //   type: "string",
  //   width: 10,
  //   visible: false,
  //   filter: true,
  // },
  // {
  //   id: "createdAt",
  //   value: "createdAt",
  //   index: 10,
  //   numeric: true,
  //   label: "Created At",
  //   type: "date",
  //   width: 10,
  //   visible: false,
  //   filter: true,
  // },
  // {
  //   id: "modifiedBy",
  //   value: "modifiedBy",
  //   index: 11,
  //   numeric: true,
  //   label: "Modified By",
  //   type: "string",
  //   width: 10,
  //   visible: false,
  //   filter: true,
  // },
  // {
  //   id: "modifiedAt",
  //   value: "modifiedAt",
  //   index: 12,
  //   numeric: true,
  //   label: "Modified At",
  //   type: "date",
  //   width: 10,
  //   visible: false,
  //   filter: true,
  // },
  // {
  //   id: "shortDescription",
  //   value: "shortDescription",
  //   index: 13,
  //   numeric: true,
  //   label: "Short Description",
  //   type: "string",
  //   width: 10,
  //   visible: false,
  //   filter: false,
  //   sort: false,
  // },
];

export interface ITableData {
  id: string;
  dataType: string;
  label: string;
  permissionResource: PolicyResource;
  data: any[];
  tableInfo: ITableColumn[];
  tableInfoDisplay: {
    tableTitle: string;
    tableDescription: string;
    noMessage: string;
  };
}
// Function used to create the dataSet needed for the table component.
// This particular dataSet contains an array with all the available data types for the advanced search functionality.
export const tableData: ITableData[] = [
  {
    id: "bidPairings",
    dataType: "bidPairings",
    label: "Bid Pairings",
    permissionResource: PolicyResource.Bidding,
    data: [],
    tableInfo: bidPairingsTableInfo,
    tableInfoDisplay: bidPairingsTableDesc,
  },
];
